// Implementa carregamento preguiçoso para seções não críticas
document.addEventListener("DOMContentLoaded", function () {
  // Seleciona todas as seções marcadas para carregamento preguiçoso
  const lazySections = document.querySelectorAll("[data-lazy-section]");

  // Configura o observador de interseção
  const observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // Obtém a seção a ser carregada
          const section = entry.target;
          const sectionId = section.getAttribute("data-section-id");
          const sectionType = section.getAttribute("data-section-type");

          if (!sectionId || !sectionType) return;

          // Carrega o conteúdo da seção
          fetch(`/?sections=${sectionId}`)
            .then((response) => response.json())
            .then((data) => {
              if (data[sectionId]) {
                // Insere o HTML da seção
                section.innerHTML = data[sectionId];
                section.removeAttribute("data-lazy-section");

                // Dispara evento para seção carregada
                const event = new CustomEvent("section:loaded", {
                  detail: { sectionId: sectionId },
                });
                document.dispatchEvent(event);
              }
            })
            .catch((error) => console.error("Error loading section:", error));

          // Para de observar depois de carregar
          observer.unobserve(section);
        }
      });
    },
    {
      rootMargin: "200px 0px", // Carrega quando chegar a 200px de distância
      threshold: 0,
    }
  );

  // Começa a observar as seções
  lazySections.forEach((section) => {
    observer.observe(section);
  });
});
